import withSidebarLayout from './withSidebarLayout';
import withTopNavLayout from './WithTopNavLayout';
import withRouter from './withRouter';
import withAuthentication from './withAuthentication';

export const pageWithLayout = (Wrapped) => {
  return withAuthentication(withTopNavLayout(withRouter(withSidebarLayout(Wrapped))));
};

export default pageWithLayout;
